export default {
  "base": "pb-4 text-muted *:first:mt-0 *:last:mb-0 *:my-1.5"
}